<template>
  <div :class="['app-field', attrs.class]" :style="attrs.style">
    <AppLabel v-if="label" :for="selectId" :required="required">{{ label }}</AppLabel>

    <ElSelect v-bind="selectAttrs" :id="selectId" class="app-select" :validate-event="validateEvent">
      <slot>
        <ElOption
          v-for="option in options"
          :key="option.value"
          :label="option.label"
          :value="option.value"
          :disabled="option.disabled"
        />
      </slot>
    </ElSelect>
  </div>
</template>

<script setup>
import { computed, useAttrs, useId } from "vue";
import { ElOption, ElSelect } from "element-plus";
import AppLabel from "@/components/ui/AppLabel.vue";

defineOptions({ inheritAttrs: false });

defineProps({
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    default: () => [],
  },
  // Off by default, see AppInput.
  validateEvent: {
    type: Boolean,
    default: false,
  },
});

const attrs = useAttrs();
const generatedId = useId();

const selectId = computed(() => attrs.id || generatedId);

// class and style belong on the wrapper; everything else goes to the Element Plus control
const selectAttrs = computed(() =>
  Object.fromEntries(Object.entries(attrs).filter(([key]) => key !== "class" && key !== "style"))
);
</script>

<style lang="scss">
.el-select.app-select {
  --el-border-color: #{$color-border-strong};
  --el-border-color-hover: #{$color-grey-10};
  --el-text-color-placeholder: #{$color-grey-10};
  width: 100%;

  .el-select__wrapper {
    border-radius: 8px;
    font-size: 15px;
    line-height: 24px;
    min-height: 42px;
    padding: 4px 14px;
  }

  .el-select__wrapper.is-focused {
    box-shadow:
      0 0 0 1px $color-primary inset,
      0 0 0 3px rgba($color-primary, 0.15);
  }

  .el-select__placeholder:not(.is-transparent) {
    color: $color-ink;
  }
}
</style>
